import { type FillCard, FillFieldKey } from '@/models/fillApplication'

const FOCUSABLE = [
  'input:not([disabled])',
  'textarea:not([disabled])',
  'button:not([disabled])',
  '[role="combobox"]',
  '[tabindex]:not([tabindex="-1"])',
].join(', ')

// A row's own line has no field on the page; its roster stands in.
const FIELD_ANCHORS: Partial<Record<string, FillFieldKey>> = {
  [FillFieldKey.DRIVER_ROWS]: FillFieldKey.DRIVERS,
  [FillFieldKey.EQUIPMENT_ROWS]: FillFieldKey.EQUIPMENT,
}

/** Scrolls to the field a check names and focuses it, else to its card; false when neither is on the page. */
export function focusFillField(field: string, card: FillCard): boolean {
  const anchor = FIELD_ANCHORS[field] ?? field
  const fieldElement = anchor ? document.querySelector<HTMLElement>(`[data-fill-field="${anchor}"]`) : null
  if (fieldElement) {
    fieldElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
    const focusable = fieldElement.matches(FOCUSABLE)
      ? fieldElement
      : fieldElement.querySelector<HTMLElement>(FOCUSABLE)
    ;(focusable ?? fieldElement).focus({ preventScroll: true })
    return true
  }
  // The card itself, not its first control: that would be the first item of its own missing list.
  const cardElement = document.querySelector<HTMLElement>(`[data-fill-card="${card}"]`)
  if (!cardElement) return false
  cardElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
  cardElement.focus({ preventScroll: true })
  return true
}

/** After a save the card refused: its first field marked invalid, else the card itself. */
export function focusFillCardError(card: FillCard): void {
  const field = document.querySelector<HTMLElement>(`[data-fill-card="${card}"] [aria-invalid="true"]`)
  if (!field) {
    focusFillField('', card)
    return
  }
  field.scrollIntoView({ behavior: 'smooth', block: 'center' })
  field.focus({ preventScroll: true })
}
